import React from "react";

const Modal = ({ show, onClose, title, children }) => {
	if (!show) {
		return null;
	}

	return (
		<>
			<div
				className="modal fade show d-block"
				tabIndex="-1"
				role="dialog"
			>
				<div className="modal-dialog h-100">
					<div className="modal-content custom-modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{title}</h5>
							<button
								type="button"
								className="btn btn-close"
								aria-label="Close"
								onClick={onClose}
							>
								{'\u2716'}
							</button>
						</div>
						<div className="modal-body">{children}</div>
					</div>
				</div>
			</div>
			<div className="modal-backdrop custom-modal-backdrop"></div>
		</>
	);
};

export default Modal;
